"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_connectivity__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "connectivity_dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129,60.09a112.19,112.19,0,0,1,13.75,15c16.69,21.85,24.11,48.07,23,74.4",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07,30.16A120.89,120.89,0,0,1,111.8,47.27",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,150.8A117,117,0,0,0,99.2,180",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,61.28a111.38,111.38,0,0,0-25,68.16",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#4a4d4e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,30.15A123,123,0,0,0,128.42,46",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,52.89a124.29,124.29,0,0,1,45.88,8.74",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75,80A113.74,113.74,0,0,1,110,54.94",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#4a4d4e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,128.72A119.54,119.54,0,0,1,41.47,97.08",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.59,146.14a119.88,119.88,0,0,0,54.53,16.53",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.32,99.5a118.34,118.34,0,0,0,26.89,34.05",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#4a4d4e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.74,40.72a131.87,131.87,0,0,0,6,38.08",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.61,
    cy: 88.89,
    r: 10.73,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.67,
    cy: 140.16,
    r: 10.73,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.64,
    cy: 53.36,
    r: 10.73,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }));
}

var _default = ic_connectivity__dark;
exports.default = _default;